/* global adRefs */
/* eslint arrow-body-style: ["error", "as-needed"]*/
export const refreshAds = (ids = []) => {
  ids.forEach(id => {
    const adRef = adRefs.find(ad => id === ad.positionId);

    if (adRef && adRef.hasOwnProperty('ref')) {
      const {adControlRef} = adRef.ref;

      if (adControlRef) {
        adControlRef.refreshAd();
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/appModules/utilities/refreshAds.js